export default __webpack_public_path__ + "static/media/zori_m.34a1281d.jpg";